/* ============================================================
   KHAVIYAR - free-delivery progress + dispatch countdown +
   delivery promise (Sydney era)

   v2, 30 Aug 2026 evening. Free delivery at $299.95+ restored
   (matches Settings > Shipping): below the threshold delivery is
   priced by postcode at checkout, insulated cold packaging
   included. 19 Sep 2026: the strip no longer quotes flat rates; parcels are StarTrack Premium next-day only (worker v4).

   1. Cart drawer + cart page strip: free-delivery progress bar
      plus next dispatch countdown.
   2. Delivery certainty line under the buy buttons.

   All times Australia/Sydney. Cutoffs: 12pm for the Sydney
   same-day zone (Mon-Fri), 11am for parcels (Mon-Wed). The line
   here is postcode-agnostic so it quotes both.

   Additive only. Injects its own styles. Never throws.
   ============================================================ */
(function () {
  "use strict";

  var TZ = "Australia/Sydney";
  var CUTOFF_GP = 12 * 60;
  var CUTOFF_EXP = 11 * 60;
  var THRESHOLD = 29995; /* cents - free delivery at $299.95+ */
  var HOLIDAYS = ["2026-10-05","2026-12-25","2026-12-28","2027-01-01","2027-01-26","2027-03-26","2027-03-29","2027-06-14","2027-10-04"];
  var DAYS = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

  var CSS = [
    ".kh-ship{margin:0 0 14px;padding:12px 14px;border:1px solid rgba(200,169,107,.35);",
    "border-radius:6px;background:rgba(200,169,107,.07);font-family:Montserrat,system-ui,sans-serif}",
    ".kh-ship__text{font-size:13px;line-height:1.4;letter-spacing:.01em}",
    ".kh-ship__text strong{font-weight:600}",
    ".kh-ship__note{display:block;margin-top:3px;font-size:11.5px;opacity:.75}",
    ".kh-ship__track{margin-top:8px;height:3px;border-radius:3px;background:rgba(200,169,107,.22);overflow:hidden}",
    ".kh-ship__fill{display:block;height:100%;background:#c8a96b;transition:width .35s ease}",
    ".kh-deliver{margin:12px 0 0;padding:10px 12px;border-left:2px solid #c8a96b;",
    "background:rgba(200,169,107,.07);font-family:Montserrat,system-ui,sans-serif;",
    "font-size:13px;line-height:1.45;letter-spacing:.01em}",
    ".kh-deliver b{font-weight:600}"
  ].join("");

  function injectCss() {
    if (document.getElementById("kh-ship-css")) return;
    var s = document.createElement("style");
    s.id = "kh-ship-css";
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function now() {
    try {
      var parts = new Intl.DateTimeFormat("en-AU", {
        timeZone: TZ, year: "numeric", month: "numeric", day: "numeric",
        weekday: "long", hour: "numeric", minute: "numeric", hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { if (p.type !== "literal") o[p.type] = p.value; });
      var hh = parseInt(o.hour, 10); if (hh === 24) hh = 0;
      return {
        y: parseInt(o.year, 10), m: parseInt(o.month, 10), d: parseInt(o.day, 10),
        dow: DAYS.indexOf(o.weekday), mins: hh * 60 + parseInt(o.minute, 10)
      };
    } catch (e) { return null; }
  }
  function pad(n) { return ("0" + n).slice(-2); }
  function isHoliday(y, m, d) { return HOLIDAYS.indexOf(y + "-" + pad(m) + "-" + pad(d)) > -1; }

  function nextDispatch(maxDow, n, cutoffMin) {
    var dt = new Date(Date.UTC(n.y, n.m - 1, n.d));
    for (var i = 0; i <= 14; i++) {
      var w = dt.getUTCDay();
      var ok = w >= 1 && w <= maxDow && !isHoliday(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate());
      if (ok && (i > 0 || n.mins < cutoffMin)) {
        return { today: i === 0, dowName: DAYS[w] };
      }
      dt.setUTCDate(dt.getUTCDate() + 1);
    }
    return null;
  }
  function countdown(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    return h > 0 ? h + "h " + m + "m" : m + "m";
  }

  /* ---- 1. cart strip ---------------------------------------------------- */

  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  function progressMarkup() {
    if (!lastCart || !lastCart.item_count) return "";
    var total = lastCart.total_price;
    if (total >= THRESHOLD) {
      return '<div class="kh-ship__text"><strong>Free delivery unlocked</strong><span class="kh-ship__note">Every order of ' + money(THRESHOLD) + ' or more ships free.</span></div><div class="kh-ship__track"><span class="kh-ship__fill" style="width:100%"></span></div>';
    }
    var remaining = THRESHOLD - total;
    var pct = Math.max(2, Math.min(100, Math.round((total / THRESHOLD) * 100)));
    return '<div class="kh-ship__text">Add <strong>' + money(remaining) + '</strong> for free delivery<span class="kh-ship__note">Otherwise priced by postcode at checkout. Insulated cold packaging always included.</span></div><div class="kh-ship__track"><span class="kh-ship__fill" style="width:' + pct + '%"></span></div>';
  }

  function stripMarkup() {
    var n = now();
    var tail = " Opt in to email + SMS tracking so it hits the fridge the moment it lands.";
    if (!n) return '<div class="kh-ship__text"><strong>Same-day Sydney &middot; next-day Australia-wide</strong><span class="kh-ship__note">Free delivery on orders $299.95+. Order by 12pm Sydney metro / 11am interstate.' + tail + "</span></div>";
    var parcels = nextDispatch(3, n, CUTOFF_EXP);
    var sydney = nextDispatch(5, n, CUTOFF_GP);
    var head, note;
    if (parcels && parcels.today) {
      head = "Order in the next <strong>" + countdown(CUTOFF_EXP - n.mins) + "</strong> for today&rsquo;s cold dispatch";
      note = "Sydney metro: delivered today by 5pm. Rest of Australia: StarTrack Premium, next business day.";
    } else if (sydney && sydney.today) {
      head = "Order in the next <strong>" + countdown(CUTOFF_GP - n.mins) + "</strong> &mdash; Sydney same-day delivery by 5pm";
      note = "Interstate orders are held cold for " + (parcels ? parcels.dowName : "Monday") + "&rsquo;s StarTrack dispatch. We dispatch Monday to Wednesday only.";
    } else {
      head = "<strong>Same-day Sydney &middot; next-day Australia-wide</strong>";
      note = "Next dispatch: Sydney same-day " + (sydney ? sydney.dowName : "Monday") + ", interstate StarTrack " + (parcels ? parcels.dowName : "Monday") + ". Order by 12pm Sydney metro / 11am interstate, Monday to Wednesday.";
    }
    return progressMarkup() + '<div class="kh-ship__text" style="margin-top:8px">' + head + '<span class="kh-ship__note">' + note + tail + "</span></div>";
  }

  var lastCart = null;
  var painting = false;

  function hosts() {
    var out = [];
    var drawer = document.querySelector("cart-drawer-component dialog .cart-drawer__content") ||
      document.querySelector("cart-drawer-component dialog");
    if (drawer) out.push(drawer);
    var page = document.querySelector(".cart__items") ||
      document.querySelector("cart-items-component") ||
      document.querySelector(".cart__summary");
    if (page && out.indexOf(page) === -1) out.push(page);
    return out;
  }

  function paint() {
    if (painting) return;
    painting = true;
    try {
      var empty = lastCart && !lastCart.item_count;
      hosts().forEach(function (host) {
        var el = host.querySelector(".kh-ship");
        if (empty) {
          if (el && el.parentNode) el.parentNode.removeChild(el);
          return;
        }
        if (!el) {
          el = document.createElement("div");
          el.className = "kh-ship";
          host.insertBefore(el, host.firstChild);
        }
        var next = stripMarkup();
        if (el.innerHTML !== next) el.innerHTML = next;
      });
    } catch (e) { /* never break the page */ }
    painting = false;
  }

  var inflight = false;
  function refresh() {
    if (inflight) return;
    inflight = true;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { inflight = false; lastCart = c; paint(); })
      .catch(function () { inflight = false; paint(); });
  }

  /* ---- 2. delivery promise under buy buttons ---------------------------- */

  function promise() {
    var n = now();
    if (!n) return "Same-day Sydney, next-day Australia-wide by StarTrack Premium. Order by <b>12pm AEST</b> Sydney metro / <b>11am AEST</b> interstate, Monday to Wednesday.";
    var parcels = nextDispatch(3, n, CUTOFF_EXP);
    if (parcels && parcels.today) {
      return "Order in the next <b>" + countdown(CUTOFF_EXP - n.mins) + "</b> &mdash; packed cold today. Sydney: at your door <b>today by 5pm</b>. Australia-wide: <b>StarTrack Premium, next business day</b>.";
    }
    var sydney = nextDispatch(5, n, CUTOFF_GP);
    if (sydney && sydney.today) {
      return "Order in the next <b>" + countdown(CUTOFF_GP - n.mins) + "</b> &mdash; Sydney metro delivered <b>today by 5pm</b>. Interstate: held cold, StarTrack dispatch <b>" + (parcels ? parcels.dowName : "Monday") + "</b>. We dispatch Monday to Wednesday only.";
    }
    return "Order now &mdash; Sydney same-day delivery <b>" + (sydney ? sydney.dowName : "Monday") + "</b>, interstate StarTrack Premium next-day dispatched <b>" + (parcels ? parcels.dowName : "Monday") + "</b>. Check your postcode above.";
  }

  function placeDelivery() {
    try {
      var text = promise();
      var anchors = [];
      var main = document.querySelector("main[data-template]");
      var tpl = main ? (main.getAttribute("data-template") || "") : "";
      if (tpl.indexOf("product") === 0) {
        var f = document.querySelector('form[action*="/cart/add"]');
        if (f) anchors.push(f);
      }
      Array.prototype.slice.call(document.querySelectorAll("[data-kh-buy]"))
        .forEach(function (p) { anchors.push(p); });
      anchors.forEach(function (a) {
        if (!a.parentNode) return;
        if (a.parentNode.querySelector(":scope > .kh-deliver")) return;
        var d = document.createElement("div");
        d.className = "kh-deliver";
        d.innerHTML = text;
        a.parentNode.insertBefore(d, a.nextSibling);
      });
    } catch (e) { /* never break the page */ }
  }

  /* ---- wiring ---------------------------------------------------------- */

  function watchDrawer() {
    var c = document.querySelector("cart-drawer-component");
    if (!c || typeof MutationObserver === "undefined") return;
    var t = null;
    new MutationObserver(function () {
      if (painting) return;
      clearTimeout(t);
      t = setTimeout(paint, 60);
    }).observe(c, { childList: true, subtree: true });
  }

  function start() {
    injectCss();
    placeDelivery();
    refresh();
    watchDrawer();
    document.addEventListener("cart:update", function () { refresh(); });
    document.addEventListener("cart:add", function () { refresh(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

